import { ConfigType } from 'dayjs';
import { localizeDate } from '../../utils/datetime';
import OverflowTooltip from '../OverflowTooltip';

const dateRenderer = (value: ConfigType, format?: string) => (
  <OverflowTooltip>
    {localizeDate(value).format(format || 'L LTS')}
  </OverflowTooltip>
);

export default dateRenderer;
